
import { computed, defineComponent } from "vue";
import { useBooks } from "@/services";
import { storeToRefs } from "pinia";

export default defineComponent({
  name: "FileSelect",
  setup() {
    const { content } = storeToRefs(useBooks());
    const selectedFile = computed(() => useBooks().file);
    const isInvalidFile = computed(() => useBooks().isFileInvalid);
    const tableColumns = computed(() => {
      if (content && content.value) {
        return content.value.slice(0, 9);
      }
      return [];
    });

    const handleFileUpload = (event: any) => {
      const file = event.target.files[0];
      useBooks().setFile(file);
    };

    return {
      tableColumns,
      selectedFile,
      isInvalidFile,
      handleFileUpload,
    };
  },
});
